'use client';

import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';
import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { me } from './business-facts';
import { pr, mr, DepositStatus, fr, dr } from './line-planner';
import { BusinessIcon } from './business-primitives';
import { AppSourceBadge } from './app-window';
export function OrderTables({ state: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5'}>
      {translateShowcaseNode(
        showcaseCopy,
        me.stages.map((t, n) => {
          let r = me.orders.filter((e) => e.stage === t);
          return (
            <div
              key={t}
              className={`flex min-h-[120px] flex-col gap-1.5 rounded-xl bg-[color-mix(in_srgb,var(--muted)_85%,transparent)] p-1.5 lg:min-h-[300px] ${e.built >= 0.55 ? 'enter' : 'invisible'} ${n > 2 ? 'max-sm:hidden' : ''} ${n > 3 ? 'max-lg:hidden' : ''}`}
              style={{
                '--i': String(n),
              }}
            >
              <p
                className={
                  'text-ink-2 flex items-center justify-between px-1.5 pt-1 pb-0.5 text-[12.5px] font-medium'
                }
              >
                {translateShowcaseNode(showcaseCopy, t)}
                <span className={'num text-ink-4 text-[12px]'}>
                  {translateShowcaseNode(showcaseCopy, r.length)}
                </span>
              </p>
              {translateShowcaseNode(
                showcaseCopy,
                r.map((t, r) => {
                  let i = pr(t, e),
                    a =
                      (t.account === 'Atelier Brun' && e.brunOverdue) ||
                      (t.account === 'Tsuki Select' && e.tsukiReceived);
                  return (
                    <div
                      key={t.id}
                      className={`relative flex flex-col gap-1.5 rounded-[10px] bg-[var(--background)] px-2.5 py-2 shadow-[var(--sh-1)] ${e.built >= 0.7 + r * 0.06 ? 'enter' : 'invisible'}`}
                      style={{
                        '--i': String(n + r),
                      }}
                    >
                      <span
                        className={'flex items-baseline justify-between gap-2'}
                      >
                        <span
                          className={
                            'text-ink min-w-0 truncate text-[13px] leading-[18px] font-medium'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, t.account)}
                        </span>
                        <span
                          className={
                            'num text-ink shrink-0 text-[12px] leading-4 max-sm:hidden'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, mr(t.total))}
                        </span>
                      </span>
                      <span
                        className={'flex items-center justify-between gap-1.5'}
                      >
                        <span
                          className={
                            'num text-ink-3 truncate font-mono text-[11px] leading-4 max-sm:hidden'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, t.id)}
                        </span>
                        <span
                          className={
                            'num text-ink-2 text-[12px] leading-4 sm:hidden'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, mr(t.total))}
                        </span>
                        {translateShowcaseNode(
                          showcaseCopy,
                          t.account === 'Tsuki Select' && !e.tsukiReceived ? (
                            <span
                              className={
                                'text-ink flex h-[22px] shrink-0 items-center rounded-md bg-[var(--background)] px-1.5 text-[11.5px] font-medium shadow-[inset_0_0_0_1px_var(--border)] transition-transform duration-150'
                              }
                              style={{
                                transform: e.pressing ? 'scale(0.94)' : 'none',
                              }}
                            >
                              {translateShowcaseNode(
                                showcaseCopy,
                                'Mark received'
                              )}
                            </span>
                          ) : (
                            <DepositStatus deposit={i} dueDate={e.dueDates} />
                          )
                        )}
                      </span>
                      {translateShowcaseNode(
                        showcaseCopy,
                        a ? (
                          <span
                            aria-hidden={!0}
                            className={
                              'bz-sheet pointer-events-none absolute inset-0 overflow-hidden rounded-[10px]'
                            }
                          >
                            <span className={'bz-flash absolute inset-0'} />
                          </span>
                        ) : null
                      )}
                    </div>
                  );
                })
              )}
            </div>
          );
        })
      )}
    </div>
  );
}
export function AppBenefits() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <ul className={'flex flex-col gap-1.5'}>
      {translateShowcaseNode(
        showcaseCopy,
        me.stockFlags.map((e, t) => {
          let n = e.flag === 'Oversold';
          return (
            <li
              key={e.style}
              className={
                'enter flex items-center gap-3 rounded-[10px] bg-[var(--background)] p-3 shadow-[var(--sh-1)]'
              }
              style={{
                '--i': String(t),
              }}
            >
              <span className={'min-w-0 flex-1'}>
                <span
                  className={
                    'text-ink block truncate text-[13.5px] font-medium'
                  }
                >
                  {translateShowcaseNode(showcaseCopy, e.style)}
                </span>
                <span className={'text-ink-3 block text-[12px]'}>
                  {translateShowcaseNode(showcaseCopy, e.detail)}
                </span>
                {translateShowcaseNode(
                  showcaseCopy,
                  n ? (
                    <span
                      className={'mt-2 flex max-w-[320px] items-center gap-2'}
                    >
                      <span
                        className={
                          'flex h-1.5 flex-1 overflow-hidden rounded-full bg-[var(--tint-2)]'
                        }
                      >
                        <span
                          className={
                            'bz-hbar block h-full w-[90%] bg-[color-mix(in_srgb,var(--foreground)_55%,transparent)]'
                          }
                        />
                        <span
                          className={
                            'bz-hbar block h-full w-[10%] bg-[oklch(0.6_0.2_25)]'
                          }
                          style={{
                            transitionDelay: '500ms',
                          }}
                        />
                      </span>
                      <span className={'num text-ink-3 shrink-0 text-[11.5px]'}>
                        {translateShowcaseNode(showcaseCopy, '10 short')}
                      </span>
                    </span>
                  ) : null
                )}
              </span>
              <span
                className={`${n ? 'bz-pop' : ''} inline-flex h-6 shrink-0 items-center gap-1 rounded-full px-2.5 text-[12px] font-medium ${n ? 'bg-[color-mix(in_srgb,oklch(0.6_0.2_25)_14%,transparent)] text-[oklch(0.52_0.19_25)]' : 'text-ink-2 bg-[var(--muted)]'}`}
                style={
                  n
                    ? {
                        animationDelay: '380ms',
                      }
                    : void 0
                }
              >
                {translateShowcaseNode(
                  showcaseCopy,
                  n ? (
                    <ShowcaseIcon name={'zap'} className={'size-3.5'} />
                  ) : (
                    <BusinessIcon name={'filter'} className={'size-3.5'} />
                  )
                )}
                {translateShowcaseNode(showcaseCopy, e.flag)}
              </span>
            </li>
          );
        })
      )}
    </ul>
  );
}
export function OrderMetrics({ state: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = fr(e),
    n = {
      'Open order value': mr(dr['Open order value'] ?? 0),
      'Deposits received': mr(t.received),
      'Deposits outstanding': mr(t.outstanding),
      'Overdue deposits': String(t.overdue),
    },
    r = (t) => e.built >= t;
  return (
    <div className={'relative h-full overflow-hidden px-4 pt-4 pb-24 md:px-5'}>
      <div
        aria-hidden={e.built > 0.15}
        className={
          'pointer-events-none absolute inset-x-0 top-[28%] flex flex-col items-center gap-2 text-center transition-[opacity,filter] duration-300'
        }
        style={
          e.built > 0.15
            ? {
                opacity: 0,
                filter: 'blur(4px)',
              }
            : void 0
        }
      >
        <span
          className={
            'text-ink-4 grid size-11 place-items-center rounded-xl shadow-[inset_0_0_0_1px_var(--border)]'
          }
        >
          <BusinessIcon name={'sparkle'} className={'size-5'} />
        </span>
        <p className={'text-ink text-[14px] font-medium'}>
          {translateShowcaseNode(
            showcaseCopy,
            'Ask for a tool. Get a working app.'
          )}
        </p>
        <p className={'text-ink-3 max-w-[300px] text-[12.5px] leading-[1.5]'}>
          {translateShowcaseNode(
            showcaseCopy,
            e.built > 0 ? 'Building it\u2026' : 'Describe it in one line below.'
          )}
        </p>
      </div>
      <div
        className={`flex items-center justify-between gap-3 ${r(0.1) ? 'enter' : 'invisible'}`}
      >
        <p className={'text-ink-3 text-[13px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            'Mercer & Vale \xB7 wholesale, FW27'
          )}
        </p>
        <AppSourceBadge kind={'built'} />
      </div>
      <dl className={'mt-3 grid grid-cols-2 gap-2 xl:grid-cols-4'}>
        {translateShowcaseNode(
          showcaseCopy,
          me.totals.map((e, t) => {
            let i = e.label === 'Overdue deposits';
            return (
              <div
                key={e.label}
                className={`rounded-xl bg-[var(--background)] px-3.5 py-2.5 shadow-[inset_0_0_0_1px_var(--border)] ${r(0.2) ? 'enter' : 'invisible'}`}
                style={{
                  '--i': String(t),
                }}
              >
                <dt
                  className={'text-ink-3 truncate text-[13px] leading-[18px]'}
                >
                  {translateShowcaseNode(showcaseCopy, e.label)}
                </dt>
                <dd
                  className={`num mt-1 text-[20px] leading-7 font-semibold tracking-[-0.01em] ${i ? 'text-[oklch(0.55_0.19_25)]' : 'text-ink'}`}
                >
                  <BlurSwap value={n[e.label] ?? ''} />
                </dd>
              </div>
            );
          })
        )}
      </dl>
      <div className={`mt-3 ${r(0.4) ? 'enter' : 'invisible'}`}>
        <div
          role={'tablist'}
          aria-label={translateShowcaseNode(
            showcaseCopy,
            'Wholesale Orders FW27'
          )}
          className={
            'inline-flex max-w-full [scrollbar-width:none] overflow-x-auto rounded-lg bg-[var(--muted)] p-[3px]'
          }
        >
          {translateShowcaseNode(
            showcaseCopy,
            me.tabs.map((t) => (
              <span
                key={t}
                role={'tab'}
                aria-selected={t === e.tab}
                className={`flex h-[30px] shrink-0 items-center rounded-md px-3 text-[13px] font-medium whitespace-nowrap transition-[background-color,color,box-shadow] duration-200 ${t === e.tab ? 'text-ink bg-[var(--background)] shadow-[0_1px_2px_rgb(0_0_0/0.08),0_0_0_1px_rgb(0_0_0/0.03)]' : 'text-ink-3'}`}
              >
                {translateShowcaseNode(showcaseCopy, t)}
              </span>
            ))
          )}
        </div>
      </div>
      <div className={'mt-3 grid'}>
        <div
          className={'panel min-w-0'}
          data-active={e.tab !== 'Stock by style'}
        >
          <OrderTables state={e} />
        </div>
        <div
          className={'panel min-w-0'}
          data-active={e.tab === 'Stock by style'}
        >
          {translateShowcaseNode(
            showcaseCopy,
            e.tab === 'Stock by style' ? <AppBenefits /> : null
          )}
        </div>
      </div>
    </div>
  );
}
export function AppRevision() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={
        'enter text-ink flex h-7 items-center gap-1.5 rounded-md bg-[var(--background)] px-2 text-[12px] shadow-[inset_0_0_0_1px_var(--border),0_1px_2px_rgb(0_0_0/0.05)]'
      }
    >
      <BusinessIcon name={'bulb'} className={'size-3.5'} />
      <span className={'hidden sm:inline'}>
        {translateShowcaseNode(showcaseCopy, 'Update recommended')}
      </span>
    </span>
  );
}
